import { BaseComponent } from '../../../../components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Modal } from '../../../../components/Modal';
import { selectHomeCompany } from '../../../Companies/selectors';
import { VehicleCMRLocation } from '../../components/VehicleCMRLocation';
import { HBox, VBox } from '../../../../components/Box';
import { FormField } from '../../../../components/FormFields';
import { Input } from '../../../../components/Input';
import { Card } from '../../../../components/Card';
import DatePicker from 'react-datepicker';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { IconRightDecorator } from '../../../../components/Icon/IconRightDecorator';
import { Calendar } from '../../../../components/Icon';

import { selectVehicleBulkActionsList } from '../../selectors';
import { VehicleCMRListItem } from '../../components/VehicleCMRListItem';
import { Button } from '../../../../components/Buttons';
import { CMRPreview } from '../../components/CMRPreview';
import ModalComponent from '../../../../containers/App/Components/Modal/Modal';
import ButtonComponent from '../../../../containers/App/Components/Button/Button';

dayjs.extend(customParseFormat);

const STATE = {
  showSelectClientModal: true,
  showOutgoingOrderModal: false,
  takingOverDate: Date.now(),
  vehicleList: [],
  showCMRPreview: false,
};

const Container = styled.div`
  font-size: 14px;
  textarea {
    resize: vertical;
    width: 100%;
  }
`;

const Address = styled.div`
  border: 1px solid rgb(21, 172, 121);
  border-radius: 6px;
  padding: 12px;
  width: 100%;
  margin: 6px 0;
  font-size: 12px;

  .button {
    margin: 0 -12px;
  }
  .name {
    font-size: 12px;
  }
  .address {
    margin-top: 12px;
  }
`;

/* eslint-disable react/prefer-stateless-function */
class PrintCMRModalComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
      vehiclesToOrder: props.vehicleIds,
    });
  }

  componentDidMount() {}

  // componentDidMount() {
  //   if (new Set(this.props.outgoingToAddressIds).size > 1) {
  //     // Using console.log instead of alert for debugging purposes
  //     console.log(this.props.outgoingToAddressIds);

  //     // Call the reset function
  //     this.props.reset();
  //   }
  // }

  get outgoingToAddressId() {
    const addressSet = new Set(this.props.outgoingToAddressIds);
    const addressSetValues = addressSet.values();

    const value = addressSetValues.next().value;

    return value;
  }

  get vehicleList() {
    if (this.props.paginatedList) {
      const values = Object.values(this.props.bulkActionList);
      const allItems = values?.reduce((prev, currentValue) => {
        const prevArray = prev?.length ? prev : [];
        const currArray = currentValue?.length ? currentValue : [];
        return [...prevArray, ...currArray];
      }, []);
      return allItems;
    }
    if (this.props.transportOrderBulk) {
      return this.props.vehicles;
    }
    return this.props.bulkActionList;
  }

  get pdfData() {
    const data = {
      sender: this.state.sender,
      consignee: this.state.consignee,
      placeDeliveryGoods: this.state.consignee?.address,
      takeOver: {
        city: this.state.takingOverCity,
        date: this.state.takingOverDate,
      },
      transporter: this.state.transporter,
      documents: this.state.attachedDocuments,
      vehicleList: this.vehicleList,
    };

    return data;
  }

  resetCurrentVehicle(vehicleId) {
    this.setState(
      prev => {
        return {
          vehiclesToOrder: prev.vehiclesToOrder.filter(id => id !== vehicleId),
        };
      },
      () => {
        if (!this.state.vehiclesToOrder[0]) {
          this.props.sendAction('close');
        }
      },
    );
  }

  getLocationData(data) {
    this.setState(prev => ({
      [data.type]: data,
      takingOverCity: data.type == 'sender' ? data?.address?.city : prev.takingOverCity,
    }));
  }

  renderTakingOverData = () => {
    return (
      <Address>
        <VBox left>
          <HBox style={{ marginBottom: '8px' }}>
            <FormField>
              <Input name="takingOverCity" value={this.state.takingOverCity} onChange={this.onInputChange.bind(this)} />
            </FormField>
          </HBox>
          <HBox style={{ width: '50%' }}>
            <FormField>
              <DatePicker
                dateFormat="dd-MM-yyyy"
                selected={this.state.takingOverDate}
                onChange={date => {
                  this.setState({ takingOverDate: date });
                }}
              />
              <IconRightDecorator icon={<Calendar />} />
            </FormField>
          </HBox>
        </VBox>
      </Address>
    );
  };

  reset() {
    this.props.sendAction('close');
  }

  save() {
    return this.props.reset();
  }

  render() {
    if (!this.state.vehiclesToOrder[0]) return null;

    return (
      <Container>
        <ModalComponent
          size={'modal-lg'}
          mobileView={this.props.mobileView}
          onClose={this.props.reset}
          title={this.lblStr('vehicle.overview.excel_card.print_cmr')}
        >
          {this.state.showCMRPreview && (
            <CMRPreview
              onClose={() => this.setState({ showCMRPreview: false })}
              data={this.pdfData}
              //defaultAddressId={this.outgoingToAddressId}
            />
          )}
          <VBox>
            <VehicleCMRLocation
              type={'sender'}
              defaultCompanyId={this.props.homeCompanyId}
              fieldNumber={'1.'}
              setLocation={this.getLocationData.bind(this)}
              title={this.lbl('vehicle.info.location.sender')}
            />
            <VehicleCMRLocation
              defaultCompanyId={this.props.outgoingToCompanyId}
              type={'consignee'}
              // defaultAddressId={this.outgoingToAddressId}
              fieldNumber={'2.'}
              setLocation={this.getLocationData.bind(this)}
              title={this.lbl('vehicle.info.location.consignee')}
            />

            <VehicleCMRLocation
              // defaultCompanyId={this.props.homeCompanyId}
              type={'placeDeliveryGoods'}
              address={this.state.consignee?.address}
              fieldNumber={'3.'}
              // setLocation={this.getLocationData.bind(this)}
              title={this.lbl('vehicle.info.location.place_delivery_goods')}
            />

            <Card className="vehicle-info-card info-card data">
              <HBox>
                <h2>
                  {'4.'}&nbsp;{this.lbl('vehicle.info.location.take_over')}
                </h2>
              </HBox>
              {this.renderTakingOverData()}
            </Card>
            <VehicleCMRLocation
              defaultCompanyId={this.props.homeCompanyId}
              type={'transporter'}
              address={this.state.transporter?.address}
              fieldNumber={'1b.'}
              setLocation={this.getLocationData.bind(this)}
              title={this.lbl('vehicle.info.location.transporter')}
            />

            <Card className="vehicle-info-card info-card data">
              <HBox>
                <h2>
                  {'5.'}&nbsp;{this.lbl('vehicle.info.location.attached_documents')}
                </h2>
              </HBox>
              <FormField>
                <textarea
                  value={this.state.attachedDocuments}
                  onChange={evt => this.setState({ attachedDocuments: evt.target.value })}
                ></textarea>
              </FormField>
            </Card>
            <Card className="vehicle-info-card info-card data">
              <HBox>
                <h2>
                  {'6.'}&nbsp;{this.lbl('vehicle.info.location.vehicles')}
                </h2>
              </HBox>
              {this.vehicleList?.map(vehicle => (
                <VehicleCMRListItem key={vehicle.id} vehicle={vehicle} />
              ))}
            </Card>
          </VBox>

          <ButtonComponent style={'ButtonSoftEditFullWidth'} onClick={this.setStateFn({ showCMRPreview: true })}>
            {this.lbl('vehicle.bulk_action.cmr.generate')}
          </ButtonComponent>
        </ModalComponent>
      </Container>
    );
  }
}

PrintCMRModalComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    homeCompanyId: selectHomeCompany(),
    bulkActionList: selectVehicleBulkActionsList(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const PrintCMRModal = compose(withConnect, withRouter, injectIntl)(PrintCMRModalComp);
